import { render, staticRenderFns } from "./MessageSidebar.vue?vue&type=template&id=a1b5f5fc&scoped=true"
import script from "./MessageSidebar.vue?vue&type=script&lang=js"
export * from "./MessageSidebar.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./MessageSidebar.vue?vue&type=style&index=0&id=a1b5f5fc&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./MessageSidebar.vue?vue&type=style&index=1&id=a1b5f5fc&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a1b5f5fc",
  "3375fbc6"
  
)

export default component.exports